import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useEditService } from '../api/editService';
import { Fields } from '../hooks/useServiceForm';

import { ServiceForm } from './ServiceForm';

type EditModalProps = {
  serviceId: string;
  initialValues: Fields;
};

export const EditModal = NiceModal.create(({ initialValues, serviceId }: EditModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useEditService({
    department: initialValues.department,
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Редактирование услуги"
    >
      <ServiceForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params, _id: serviceId })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
